import { atom } from 'recoil';
export const scrollOffsetAtom = atom({
    key: 'local/scrollOffset',
    default: 0,
});
export const shortcutKeysAtom = atom({
    key: 'local/shortcutKeys',
    default: [],
});
export const featureFlagsAtom = atom({
    key: 'featureFlagBag',
    default: {},
});
